import { NgModule } from '@angular/core';

import { SelectOptionDirective } from './select-option.directive';
import { SelectComponent } from './select.component';
import { SelectTranslateModule } from './translation-loader';

@NgModule({
  imports: [SelectTranslateModule, SelectComponent, SelectOptionDirective],
  exports: [SelectComponent, SelectOptionDirective],
})
export class SelectModule {}
